<template>
  <q-item v-bind="passedProps" :class="[selected ? 'bg-primary-40' : '']">
    <q-item-section>
      <q-item-label class="text-sm">
        <span class="text-neutral"
          >{{ address.city }}, {{ address.state }} ({{ address.state_code }}),
          {{ address.pincode }}</span
        >
      </q-item-label>
      <q-item-label v-if="address.gstin || address.state" caption>
        <span class="text-neutral-70"
          >{{ address.address_line }} {{ address.address }}, {{ address.city }},
          {{ address.state }} ({{ address.state_code }}),
          {{ address.pincode }}</span
        >
        <span v-if="address.gstin" class="text-neutral-70 block">
          GSTIN: {{ gstin }}
        </span>
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script setup>
defineProps({
  address: {
    type: Object,
    default: () => {
      return {};
    },
  },
  gstin: {
    type: String || Number,
    default: "",
  },
  selected: {
    type: Boolean,
    default: false,
  },
  passedProps: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
</script>
